// extracted by mini-css-extract-plugin
module.exports = {"body":"style__body__rfWTs","content":"style__content__iWt7U","footer":"style__footer__Hqc5b"};